'use strict';exports.__esModule = true;exports.getSearchDescription = exports.getSearchTitle = undefined;var _formatSEOData = require('../formatSEOData');
var _title = require('./residense/title');var _title2 = _interopRequireDefault(_title);
var _title3 = require('./projects/title');var _title4 = _interopRequireDefault(_title3);
var _description = require('./residense/description');var _description2 = _interopRequireDefault(_description);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var isNotResidence = function isNotResidence(section) {return section !== 'projects' && section === 'commercial';};

var getSearchTitle = exports.getSearchTitle = function getSearchTitle() {var routeData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var translate = arguments[1];var customParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};var

  section =
  routeData.location;
  switch (section) {
    case 'homes':
      return (0, _title2.default)(routeData, translate);
    case 'projects':
      return (0, _title4.default)(routeData, translate);
    case 'commercial':
    default:
      return (0, _formatSEOData.formatSearchTitle)(routeData, translate, customParams);}

};

var getSearchDescription = exports.getSearchDescription = function getSearchDescription() {var routeData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var translate = arguments[1];var customParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};var

  section =
  routeData.location;

  return isNotResidence(section) ?
  (0, _formatSEOData.formatSearchDescription)(routeData, translate, customParams) :
  (0, _description2.default)(routeData, translate, customParams);
};


//////////////////
// WEBPACK FOOTER
// ./src/utils/seo/index.js
// module id = 3104
// module chunks = 0